import { render, staticRenderFns } from "./ChangeFailed.vue?vue&type=template&id=36bf5f10&scoped=true&"
import script from "./ChangeFailed.vue?vue&type=script&lang=ts&"
export * from "./ChangeFailed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf5f10",
  null
  
)

export default component.exports